/**
 * @file 公共工具
 */
// import { Toast } from '@nutui/nutui';
// import loading from "@/assets/img/loading.png";
// import alert_wrong from "@/assets/img/alert_wrong.png";
import { JSEncrypt } from 'encryptlong'
// import { compress, compressAccurately } from 'image-conversion'
import * as imageConversion from 'image-conversion'
// const imageConversion = require('image-conversion')
/**
 * canvas 图片居中
 */
const imgCenterFunc = (pw, ph, w, h) => {
  let px = 0;
  let py = 0;
  if (pw < w && ph < h) {
    px = 0.5 * w - 0.5 * pw;
    py = 0.5 * h - 0.5 * ph;
  } else if (ph / pw > h / w) {
    let uu = ph;
    ph = h
    pw = pw * h / uu
    px = 0.5 * w - 0.5 * pw;
  } else {
    let uu = pw;
    pw = w;
    ph = ph * pw / uu
    py = 0.5 * h - 0.5 * ph;
  }
  return { px, py, pw, ph }
};


/**
 * 倒计时
 */
const countdown = (startTime, interval = 2) => {
  let nowTime = Date.parse(appModelDate(toYYMMDDHMS(new Date())));
  const endTime = startTime + 3600000 * interval;
  const leftTime = endTime - nowTime;
  if (leftTime <= 0) return '00:00:00';
  return toHHmmss(leftTime);
};

/**
 * 不满两位数补零
 */
const toHHmmss = (date) => {
  const hours = parseInt((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = (date % (1000 * 60)) / 1000;
  return `${hours < 10 ? ('0' + hours) : hours}:${minutes < 10 ? ('0' + minutes) : minutes}:${seconds < 10 ? ('0' + seconds) : seconds}`;
};

/**
 * 距离
 */
const toRadians = (d) => { return d * Math.PI / 180; };

const distance = (lat1, lng1, lat2, lng2) => {
  let dis = 0;
  const radLat1 = toRadians(lat1);
  const radLat2 = toRadians(lat2);
  const deltaLat = radLat1 - radLat2;
  const deltaLng = toRadians(lng1) - toRadians(lng2);
  dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
  dis = (dis * 6378137).toFixed(0).toString();
  if (dis > 999) dis = `${(dis / 1000).toFixed(2)}千`;
  return dis;
};

/**
 * 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
 */
function getDistance(lat1, lng1, lat2, lng2) {
  let radLat1 = toRadians(lat1);
  let radLat2 = toRadians(lat2);
  let a = radLat1 - radLat2;
  let b = toRadians(lng1) - toRadians(lng2);
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
      Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137; // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000; //输出为公里
  let distance = s;
  let distance_str = "";
  distance_str = distance * 1000 // 单位 米
  console.info('lyj 距离是', s);
  console.info('lyj 距离是', distance_str);
  return distance_str;
}

/**
 * 节流
 */
const throttle = (fun, delay) => {
  let last, deferTimer
  return function () {
    let that = this
    let _args = arguments
    let now = +new Date()
    if (last && now < last + delay) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(function () {
        last = now
        fun.apply(that, _args)
      }, delay)
    } else {
      last = now
      fun.apply(that, _args)
    }
  }
};

/**
 * 返回 yyyy-mm-dd h:m:s
 */
const add0 = (m) => { return m < 10 ? '0' + m : m }
export const toYYMMDDHMS = (date) => {
  const time = new Date(date);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
};

/**
 * 传入 '2021-02-02 20:20:20' => new Date()
 */
export const appModelDate = (date) => {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  const window = u.indexOf('Windows') > -1
  const mac = /macintosh|mac os x/i.test(u)
  if (isiOS) return new Date(date.replace(/-/g, '/'));
  if (isAndroid) return new Date(date);
  if (window) return new Date(date);
  if (mac) return new Date(date);
};

/**
 * 获取定位
 */
export const getCurrentLocation = () => {
  return new Promise((resolve) => {
    if (!window.mqq) {
      window.mqq.invoke("common", "getPosition", {}, function (datas) {
        if (datas.status) {
          // toastInit('请打开手机定位！', 'text', 2000)
          resolve([39.908552, 116.397472]);
        } else {
          const lat = datas.lat / 1000000;
          const lon = datas.lon / 1000000;
          resolve([lat, lon]);
        }
      });
    } else {
      // 本地调试
      resolve([39.86077900000002, 116.39126300000002]);
    }
  });
};

//判断系统类型
export function isPlatformPC(){
  var agent = navigator.userAgent.toLowerCase();
  var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
    //your code
    return true 
  }
  if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
    //your code
    return true
  }
  if(isMac && !agent.includes('iPhone')){
    //your code
    return true
  }
  return false;
}

/**
 * 压缩图片
 */
export const setMiniImg = (file) => {
    console.log(file)
    // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    // const isLt2M = file.size / 1024 / 1024 < 2
    // if (!isJpgOrPng) {
    //     // this.$message.error('上传头像图片只能是JPG或PNG格式')
    //     // return false
    //     return new Promise((resolve) => {
    //       // 以质量
    //       // compress
    //         // 压缩到100KB,这里的100就是要压缩的大小，可自定义
    //         // imageConversion.compressAccurately(file, 600).then((res) => {
    //             resolve(false)
    //         // })
    //     })
    // }
    // if (!isLt2M) {
    //     // this.$message.error('上传头像图片大小不能超过2MB')
    //     return new Promise((resolve) => {
    //       // 以质量
    //       // compress
    //         // 压缩到100KB,这里的100就是要压缩的大小，可自定义
    //         // imageConversion.compressAccurately(file, 600).then((res) => {
    //             resolve(false)
    //         // })
    //     })
        
    // }
    return new Promise((resolve) => {
      // 以质量
      // compress
        // 压缩到100KB,这里的100就是要压缩的大小，可自定义
        imageConversion.compressAccurately(file, 600).then((res) => {
            resolve(res)
        })
    })

  // return new Promise((resolve) => {
  //   let rate = 0.1;
  //   let reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   let img = new Image();
  //   reader.onload = function (e) {
  //     img.src = e.target.result;
  //   };
  //   img.onload = function () {
  //     let canvas = document.createElement("canvas");
  //     let context = canvas.getContext("2d");
  //     // 文件大小KB
  //     const fileSizeKB = Math.floor(file.size / 1024);
  //     // 配置rate和maxSize的关系
  //     if (fileSizeKB * rate > 3027) {
  //       rate = Math.floor((3027 / fileSizeKB) * 10);
  //     }
  //     // 缩放比例，默认0.5
  //     let targetW = (canvas.width = this.width * rate);
  //     let targetH = (canvas.height = this.height * rate);
  //     context.clearRect(0, 0, targetW, targetH);
  //     context.drawImage(img, 0, 0, targetW, targetH);
  //     canvas.toBlob((blob) => {
  //       const newImage = new File([blob], file.name, {
  //         type: file.type,
  //       });
  //       console.log(newImage, newImage.size, "kb");
  //       resolve(newImage);
  //     });
  //   };
  // })
}

/**
 * Encrypt **加密**
 */
export const encryptFun = (obj, publicKey) => {
  //**加密**
  let encrypt = new JSEncrypt();
  //设置公钥
  encrypt.setPublicKey(publicKey);
  //用公钥加密明文
  let encrypted = encrypt.encryptLong(obj);
  return encrypted
}

/**
 * Encrypt **解密**
 */
export const decryptFun = (obj, privateKey) => {
  // **解密**
  let decrypt = new JSEncrypt();
  //设置私钥
  decrypt.setPrivateKey(privateKey);
  //使用私钥解密刚才用公钥加密的密文
  let uncrypted = decrypt.decryptLong(obj);
  return uncrypted
}
    
// export const toastInit = (
//   text = "任务加载中...",
//   type = "loading",
//   duration = 0
// ) => {
//   Toast[type](text, {
//     icon: type === 'loading' ? loading : type === 'fail' ? alert_wrong : '',
//     bgColor: "#17181A",
//     duration,
//     cover: false,
//     coverColor: "rgba(0, 0, 0, 0)",
//   });
// };

export default {
  imgCenterFunc, countdown, distance, throttle, getDistance
};
